module.exports = __webpack_public_path__ + "03a23436e155f676f132a9355e00d9ed.png";